<template>
  <div :class="$style.syncCalendarModalList">
    <p :class="$style.desc">
      В календаре появятся только те мероприятия, где вы организатор или
      участник.
    </p>

    <ul :class="$style.list">
      <li v-for="(item, idx) in list" :key="idx" :class="$style.item" @click="$emit('select', idx)">
        <img :class="$style.itemIcon" :src="require(`@/assets/img/svg/${item.icon}.svg`)" alt="service-logo">
        <span>{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "syncCalendarModalList",

  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" module>
.syncCalendarModalList {
  .itemIcon {
    width: 40px;
    height: 40px;
    margin-right: 20px;
    fill: none;
  }
}

.list {
  display: flex;
  flex-direction: column;
}

.desc {
  margin-bottom: 36px;
  font-size: 15px;
}

.item {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border: 1px solid $base-border-clr;
  border-radius: 10px;
  background-color: transparent;
  transition-duration: 0.3s;
  transition-property: background-color;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  &:hover {
    background-color: $base-border-clr;
  }
}
</style>
